export default __webpack_public_path__ + "static/fire-579957410aeb9563a8ef092708666952.png";